module.exports = __webpack_public_path__ + "static/media/Arrow.30e8e271.svg";